/*消息总线*/
import Vue from 'vue'

export default new Vue({
  methods: {
    on: function (event, callback) {
      this.$off(event, callback).$on(event, callback);
    },
    emit: function (event, ...obj) {
      this.$emit(event, ...obj);
    }
  }
});
